import { jsx as _jsx } from "react/jsx-runtime";
import { useAetherContext } from '#pplx/frontend/aether/components/AetherProvider/useAetherContext.js';
import { MenuItemBase } from '#pplx/frontend/aether/components/internal/menu/MenuItemBase.js';
import { MenuItemPrimitive } from '#pplx/frontend/aether/components/internal/menu/MenuItemPrimitive.js';
import { useMenuClose } from '#pplx/frontend/aether/components/internal/menu/useMenuContext.js';
import { useCallback } from 'react';
export function MenuItem({ children, textValue, disabled, onSelect, closeOnSelect = true, leadingAccessory, trailingAccessory, subtitle, textOverflow, badge, badgeVariant, className, variant = 'default', ...rest }) {
    const { isMobileStyle } = useAetherContext();
    const closeMobileMenu = useMenuClose();
    const handleSelectTextValue = useCallback((event) => {
        if (disabled) {
            return;
        }
        if (!closeOnSelect) {
            // Radix dismisses the menu after selection unless its select event is canceled.
            event?.preventDefault();
        }
        onSelect();
        return true;
    }, [disabled, onSelect, closeOnSelect]);
    const mobileHandleSelectTextValue = useCallback(() => {
        const handled = handleSelectTextValue();
        if (!handled || !closeOnSelect) {
            return;
        }
        // Close the menu manually for mobile bottom sheet
        closeMobileMenu?.();
    }, [handleSelectTextValue, closeMobileMenu, closeOnSelect]);
    const mobileHandleKeyDown = useCallback((e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            // Prevent default to avoid scrolling on Space key
            e.preventDefault();
            mobileHandleSelectTextValue();
        }
    }, [mobileHandleSelectTextValue]);
    // Mobile renders within a dialog (i.e: bottom sheet) so
    // we don't need to wrap within an accessible menu item
    // and just render as standard button.
    if (isMobileStyle) {
        return (_jsx(MenuItemBase, { leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, textOverflow: textOverflow, badge: badge, badgeVariant: badgeVariant, className: className, variant: variant, role: "button", tabIndex: disabled ? -1 : 0, onClick: mobileHandleSelectTextValue, onKeyDown: mobileHandleKeyDown, "aria-disabled": disabled, ...rest, children: children }));
    }
    return (_jsx(MenuItemPrimitive, { disabled: disabled, onSelect: handleSelectTextValue, textValue: textValue, asChild: true, ...rest, children: _jsx(MenuItemBase, { leadingAccessory: leadingAccessory, trailingAccessory: trailingAccessory, subtitle: subtitle, textOverflow: textOverflow, badge: badge, badgeVariant: badgeVariant, className: className, variant: variant, children: children }) }));
}
//# sourceMappingURL=MenuItem.js.map